
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://static.readdy.ai/image/0cfd59917bf6d9fd5d310c0650be524a/f8ab8bcec9a7e9922eda1fb6f34845be.png" 
                alt="Langfeldt Mechanical LLC" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-400 mb-4">
              Veteran-owned HVAC company serving Western Michigan since 2013.
            </p>
            <div className="flex items-center gap-2 text-gray-400">
              <i className="ri-shield-star-fill text-yellow-400"></i>
              <span className="text-sm">Licensed &amp; Insured</span>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services/heating" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Heating
                </Link>
              </li>
              <li>
                <Link to="/services/cooling" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Cooling
                </Link>
              </li>
              <li>
                <Link to="/services/commercial-refrigeration" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Commercial Refrigeration
                </Link>
              </li>
              <li>
                <Link to="/emergency-service" className="text-red-400 hover:text-red-300 transition-colors font-semibold cursor-pointer">
                  Emergency Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/service-areas" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Service Areas
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-phone-fill text-red-500 mt-1"></i>
                <div>
                  <a href="tel:2313988023" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                    (231) 398-8023
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-fill text-red-500 mt-1"></i>
                <div className="text-gray-400">
                  4114 S Stiles Rd<br />
                  Scottville, MI 49454
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-fill text-red-500 mt-1"></i>
                <div className="text-gray-400">
                  Mon–Fri: 8:00 AM – 5:00 PM
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm text-center md:text-left">
            © {new Date().getFullYear()} Langfeldt Mechanical LLC. All rights reserved. Veteran-Owned.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
